const config = {
  url: window.location.hostname === 'slowpokecorner.com' 
        ? 'https://slowpokecorner.com/'
       : 'https://slowpokecorner.com/'
  }

export default config;